import React, { useState } from 'react';
import { HandHoldingPhoneImage, NotifyGlowImage, UnionIcon } from '../../assets';

const WAITLIST_API_URL = process.env.REACT_APP_WAITLIST_API_URL || 'http://localhost:5300';

const Header = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setStatus('submitting');
    setMessage('');

    try {
      const response = await fetch(`${WAITLIST_API_URL}/api/Waitlist/Join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ Email: email.trim() }),
      });
      const data = await response.json();

      if (response.ok && data.isSuccessful) {
        setStatus('success');
        setMessage("You're on the list! We'll notify you when Meind launches.");
        setEmail('');
      } else {
        setStatus('error');
        setMessage(data.message || 'Something went wrong. Please try again.');
      }
    } catch {
      setStatus('error');
      setMessage('Something went wrong. Please try again.');
    }
  };

  return (
    <header className="text-center relative overflow-hidden px-6">
    <div className="mt-60 mb-8">
      <h1 className="text-5xl lg:text-7xl max-w-[800px] mx-auto mb-[22px] tracking-tighter">
        <span className="bg-clip-text gradient-text bg-gradient-to-r from-[#F6C1C9] via-[#A1CEEB] to-[#0B1956]">
          Streamlining service{" "}
        </span>
        procedures for Heros
      </h1>
      <p className="text-xl text-[#667085] max-w-[540px] mx-auto">
        Meind Therapy helps health and beauty Heros - wellness, spa, massage, and
        beauty professionals - simplify bookings, scheduling, and client care.
      </p>
    </div>

    <form onSubmit={handleSubmit} className="flex gap-3 md:gap-5 justify-center items-center max-w-[542px] mx-auto">
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        disabled={status === 'submitting'}
        className="rounded-lg border-2 border-[#E0DFDF] grow h-[50px] px-6"
        placeholder="Enter your email"
      />
      <div className="relative shrink-0 flex items-center justify-center">
        <img
          src={NotifyGlowImage}
          alt=""
          aria-hidden="true"
          className="pointer-events-none absolute left-1/2 top-1/2 w-[140px] h-[140px] -translate-x-1/2 -translate-y-1/2 opacity-80 select-none"
        />
        <button
          type="submit"
          disabled={status === 'submitting'}
          className="relative z-[1] border-2 border-[#0B1956] px-5 h-[50px] rounded-lg button_hover bg-white disabled:opacity-60"
        >
          {status === 'submitting' ? 'Joining...' : 'Notify me'}
        </button>
      </div>
    </form>
    {message && (
      <p className={`mt-3 text-sm ${status === 'success' ? 'text-[#0B1956]' : 'text-red-500'}`}>
        {message}
      </p>
    )}
    <img
      className="block w-[80%] max-w-[660px] ml-[15%] md:ml-[25%] xl:ml-[35%] mt-[74px]"
      src={HandHoldingPhoneImage}
      alt="Meind Therapy app for health and beauty booking on a smartphone"
      loading="lazy"
    />
    <img
      className="absolute bottom-0 w-full z-[-1] left-0"
      src={UnionIcon}
      alt=""
      loading="lazy"
      aria-hidden="true"
    />
  </header>
  )
}

export default Header
